import React, { Component } from "react";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import { connect } from "react-redux";
import AttIcon from "../../assets/images/carriers/att.jpg";
import SwbellIcon from "../../assets/images/carriers/SwBell.png";
import Verizoncon from "../../assets/images/carriers/verizon.jpg";
import SprintIcon from "../../assets/images/carriers/sprint.jpg";
import TmobileIcon from "../../assets/images/carriers/t-mobile.jpg";
import SearchResultHeader from "./SearchResultHeader";
import { getMenuItem } from "../common/PageHelper";

class CarrierLookupResult extends Component {
  getPhoneCarrierImage = (name) => {
    if (
      name.indexOf("att") !== -1 ||
      name.indexOf("Blue Licenses") !== -1 ||
      name.indexOf("ATT MOBIL") !== -1
    ) {
      return AttIcon;
    }
    if (name.indexOf("BELLSOUTH") !== -1) {
      return SwbellIcon;
    }
    if (name.indexOf("erizon") !== -1 || name.indexOf("ERIZON") !== -1) {
      return Verizoncon;
    }
    if (name.indexOf("Sprint") !== -1 || name.indexOf("SPRINT") !== -1) {
      return SprintIcon;
    }
    if (name.indexOf("T-Mobile") !== -1 || name.indexOf("T-MOBILE") !== -1) {
      return TmobileIcon;
    }
    return "";
  };
  render() {
    const results = [];
    let tabHeader = null;
    if (
      this.props.searchResultData !== undefined &&
      this.props.searchResultData !== null &&
      this.props.searchResultData !== ""
    ) {
      const records = _.get(
        this.props.searchResultData,
        `${Object.keys(this.props.searchResultData)[0]}.listing[0].carrier247`
      );

      const showNarrowSearchMessage = records && records.length > 25;
      tabHeader = (
        <SearchResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          log={_.get(
            this.props.searchResultData,
            `${Object.keys(this.props.searchResultData)[0]}.log[0]`
          )}
          {...this.props}
          printContent={this.props.printContent}
        />
      );

      if (records !== undefined) {
        _.forEach(records, (record, index) => {
          const operatingCarriers = _.get(record, "operatingCarrier");
          if (operatingCarriers !== undefined) {
            _.forEach(operatingCarriers, (operatingCarrier, optIndex) => {
              results.push(
                <Table.Row key={`Carrier_Lookup_Name_Row_${index}_${optIndex}`}>
                  <Table.Cell>
                    <ul>
                      <li className="noBullet">
                        {_.get(operatingCarrier, "name[0]._", "")}
                      </li>
                      <li className="noBullet">
                        {_.get(operatingCarrier, "contactAddress[0]._", "")}
                      </li>
                      <li className="noBullet">{`${_.get(
                        operatingCarrier,
                        "contactCity[0]._",
                        ""
                      )} ${_.get(
                        operatingCarrier,
                        "contactState[0]._",
                        ""
                      )} ${_.get(
                        operatingCarrier,
                        "contactPostalCode[0]._",
                        ""
                      )}`}</li>
                      <li className="noBullet">{`${_.get(
                        operatingCarrier,
                        "contactFirstName[0]._",
                        ""
                      )} ${_.get(
                        operatingCarrier,
                        "contactLastName[0]._",
                        ""
                      )}`}</li>
                      <li className="noBullet">
                        {_.get(operatingCarrier, "contactPhone[0]._", "")}
                      </li>
                    </ul>
                  </Table.Cell>
                </Table.Row>
              );
            });
          }
        });
      }
    }

    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${results.length > 0 ? results.length : 0} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          <Table stackable className={"table-custom-strip"}>
            <Table.Body>
              <Table.Row className={"result-header"}>
                <Table.HeaderCell>
                  Carrier Contact/Subpoena Information
                </Table.HeaderCell>
              </Table.Row>
              {results}
            </Table.Body>
          </Table>
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(CarrierLookupResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/CarrierLookupResult.js